import React from 'react'
import { Modal, Form, Input } from '@surecompanies/core_components'
import styled from 'styled-components'
import { PaymentAssignmentRole } from '../Utils/roles'

const SummaryText = styled.div`
  font-size: 14px;
  color: #3a4951;
  margin-bottom: 16px;
`

export type BulkUnassignType =
  | PaymentAssignmentRole.MAKER
  | PaymentAssignmentRole.ESCALATOR

interface BulkUnassignModalProps {
  visible: boolean
  unassignType: BulkUnassignType
  caseCount: number
  onClose: () => void
  onConfirm: (notes: string) => Promise<void>
}

export default function BulkUnassignModal({
  visible,
  unassignType,
  caseCount,
  onClose,
  onConfirm,
}: BulkUnassignModalProps) {
  const [form] = Form.useForm()
  const [submitting, setSubmitting] = React.useState(false)

  const label =
    unassignType === PaymentAssignmentRole.MAKER ? 'Maker' : 'Escalator'
  const title = `Unassign ${label}`

  const handleCancel = () => {
    if (submitting) return
    form.resetFields()
    onClose()
  }

  const handleOk = async () => {
    if (submitting) return
    try {
      const values = await form.validateFields()
      setSubmitting(true)
      await onConfirm(values.notes || '')
      form.resetFields()
      onClose()
    } catch {
      // validation errors are shown inline
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Modal
      title={title}
      open={visible}
      onCancel={handleCancel}
      onOk={handleOk}
      okText="Unassign"
      okButtonProps={{ danger: true, loading: submitting }}
      cancelButtonProps={{ disabled: submitting }}
      maskClosable={!submitting}
      keyboard={!submitting}
      width={460}
      centered
      destroyOnClose
    >
      <SummaryText>
        Remove {label.toLowerCase()} from <strong>{caseCount}</strong> case
        {caseCount !== 1 ? 's' : ''}?
      </SummaryText>

      <Form form={form} layout="vertical" preserve={false}>
        <Form.Item name="notes" label="Notes (optional)">
          <Input.TextArea
            rows={4}
            placeholder={`Add any relevant notes about this ${label.toLowerCase()} removal...`}
            style={{ resize: 'vertical' }}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}
